/**
 * Ring Sizer — Alpine.js component
 * Casey Fuchs Jewelry · caseyfuchs.com
 */

(function () {
  function ringSizerComponent() {
    return {

      // Navigation
      activeTab: 'find',

      // Section 1: Size converter
      circumference: null,
      diameter: null,
      euSize: null,
      usSize: null,
      sizeNote: '',

      // Section 2: Ring matcher
      step: 'calibrate',
      calibrationObjectMm: 85.6,
      calibrationObjectHeight: 53.98,
      calibrationObjectLabel: 'Credit / debit card',
      calibrationShape: 'rect',
      calibrationPx: 323,
      pxPerMm: 3.78,
      ringMatchPx: 60,
      ringMatchMin: 30,
      ringMatchMax: 120,
      matchedEu: null,
      matchedUs: null,
      matchedNote: '',
      ringMatchDiameterMm: 0,

      // Section 3: Print preview
      pxPerMmScreen: 3.78,

      // Calibration objects
      calibrationObjects: [
        { label: 'Credit / debit card', mm: 85.6, height: 53.98, shape: 'rect' },
        { label: '1 euro coin', mm: 23.25, height: 23.25, shape: 'circle' },
        { label: 'US quarter', mm: 24.26, height: 24.26, shape: 'circle' },
      ],

      // EU + US ring size data
      // US values match the EU/US pairing used on Casey Fuchs product variants
      // (e.g. EU 52 = US 6) so the guide and the size dropdown never disagree.
      sizeTable: [
        { eu: 44, us: '3',    circ: 44.0, diam: 14.0 },
        { eu: 45, us: '3¼',   circ: 45.0, diam: 14.3 },
        { eu: 46, us: '3¾',   circ: 46.0, diam: 14.6 },
        { eu: 47, us: '4',    circ: 47.0, diam: 15.0 },
        { eu: 48, us: '4½',   circ: 48.0, diam: 15.3 },
        { eu: 49, us: '5',    circ: 49.0, diam: 15.6 },
        { eu: 50, us: '5¼',   circ: 50.0, diam: 15.9 },
        { eu: 51, us: '5½',   circ: 51.0, diam: 16.2 },
        { eu: 52, us: '6',    circ: 52.0, diam: 16.6 },
        { eu: 53, us: '6¼',   circ: 53.0, diam: 16.9 },
        { eu: 54, us: '6¾',   circ: 54.0, diam: 17.2 },
        { eu: 55, us: '7',    circ: 55.0, diam: 17.5 },
        { eu: 56, us: '7½',   circ: 56.0, diam: 17.8 },
        { eu: 57, us: '8',    circ: 57.0, diam: 18.1 },
        { eu: 58, us: '8¼',   circ: 58.0, diam: 18.5 },
        { eu: 59, us: '8¾',   circ: 59.0, diam: 18.8 },
        { eu: 60, us: '9',    circ: 60.0, diam: 19.1 },
        { eu: 61, us: '9½',   circ: 61.0, diam: 19.4 },
        { eu: 62, us: '10',   circ: 62.0, diam: 19.7 },
        { eu: 63, us: '10¼',  circ: 63.0, diam: 20.1 },
        { eu: 64, us: '10½',  circ: 64.0, diam: 20.4 },
        { eu: 65, us: '11',   circ: 65.0, diam: 20.7 },
        { eu: 66, us: '11½',  circ: 66.0, diam: 21.0 },
        { eu: 67, us: '11¾',  circ: 67.0, diam: 21.3 },
        { eu: 68, us: '12',   circ: 68.0, diam: 21.6 },
      ],

      // Printable sizes (48–68)
      get printSizes() {
        return this.sizeTable.filter(function (r) {
          return r.eu >= 48 && r.eu <= 68;
        });
      },

      // Calibration circle height in px (for credit card aspect ratio)
      get calibrationHeightPx() {
        return Math.round(this.calibrationPx * (this.calibrationObjectHeight / this.calibrationObjectMm));
      },

      init() {
        this.pxPerMm = 96 / 25.4;
        this.pxPerMmScreen = this.pxPerMm;
        this.calibrationPx = Math.round(this.calibrationObjectMm * this.pxPerMm);
        this._updateMatchRange();
      },

      // Section 1

      updateFromCircumference() {
        if (!this.circumference || this.circumference < 40 || this.circumference > 76) {
          this.euSize = null;
          this.usSize = null;
          this.sizeNote = '';
          this.diameter = null;
          return;
        }
        this.diameter = parseFloat((this.circumference / Math.PI).toFixed(1));
        this._findSize(this.circumference);
      },

      updateFromDiameter() {
        if (!this.diameter || this.diameter < 12 || this.diameter > 25) {
          this.euSize = null;
          this.usSize = null;
          this.sizeNote = '';
          this.circumference = null;
          return;
        }
        this.circumference = parseFloat((this.diameter * Math.PI).toFixed(1));
        this._findSize(this.circumference);
      },

      _findSize(circ) {
        var closest = this.sizeTable[0];
        var minDiff = Math.abs(circ - closest.circ);

        for (var i = 0; i < this.sizeTable.length; i++) {
          var row = this.sizeTable[i];
          var diff = Math.abs(circ - row.circ);
          if (diff < minDiff) {
            minDiff = diff;
            closest = row;
          }
        }

        this.euSize = closest.eu;
        this.usSize = closest.us;

        if (minDiff < 0.3) {
          this.sizeNote = '';
        } else if (minDiff < 1) {
          this.sizeNote = 'Closest standard size (' + minDiff.toFixed(1) + ' mm ' + (circ > closest.circ ? 'above' : 'below') + ')';
        } else {
          this.sizeNote = 'Between sizes. Try the ring matcher for a more precise fit.';
        }
      },

      // Section 2

      selectCalibrationObject(obj) {
        this.calibrationObjectMm = obj.mm;
        this.calibrationObjectHeight = obj.height;
        this.calibrationObjectLabel = obj.label;
        this.calibrationShape = obj.shape;
        this.calibrationPx = Math.round(obj.mm * this.pxPerMm);
        this.step = 'calibrate';
        this.matchedEu = null;
        this.matchedUs = null;
      },

      updateCalibration() {
        this.pxPerMm = this.calibrationPx / this.calibrationObjectMm;
      },

      confirmCalibration() {
        this._updateMatchRange();
        this.ringMatchPx = Math.round(16.6 * this.pxPerMm);
        this.step = 'match';
      },

      resetCalibration() {
        this.step = 'calibrate';
        this.matchedEu = null;
        this.matchedUs = null;
        this.matchedNote = '';
        this.calibrationPx = Math.round(this.calibrationObjectMm * this.pxPerMm);
      },

      _updateMatchRange() {
        // EU 44 = 14.0mm, EU 68 = 21.6mm — add small padding
        this.ringMatchMin = Math.round(13.0 * this.pxPerMm);
        this.ringMatchMax = Math.round(23.0 * this.pxPerMm);
      },

      updateRingMatch() {
        this.ringMatchDiameterMm = this.ringMatchPx / this.pxPerMm;
        var circ = this.ringMatchDiameterMm * Math.PI;

        var closest = this.sizeTable[0];
        var minDiff = Math.abs(circ - closest.circ);
        for (var i = 0; i < this.sizeTable.length; i++) {
          var row = this.sizeTable[i];
          var diff = Math.abs(circ - row.circ);
          if (diff < minDiff) {
            minDiff = diff;
            closest = row;
          }
        }

        this.matchedEu = closest.eu;
        this.matchedUs = closest.us;
        if (minDiff < 0.5) {
          this.matchedNote = this.ringMatchDiameterMm.toFixed(1) + ' mm diameter';
        } else {
          this.matchedNote = this.ringMatchDiameterMm.toFixed(1) + ' mm diameter (closest standard size)';
        }
      },

    };
  }

  if (window.Alpine) {
    window.Alpine.data('RingSizer', ringSizerComponent);
  }
  document.addEventListener('alpine:init', function () {
    Alpine.data('RingSizer', ringSizerComponent);
  });
})();
